import { constants } from "shared/constants";
import { CompanyBasedSectionReports } from "./CompanyBasedSectionReports";

const salesOverviewSectionReports = [
    constants.v360ReportCodes.intermediary.salesOverviewSection.monthly,
    constants.v360ReportCodes.intermediary.salesOverviewSection.claimRatio,
    constants.v360ReportCodes.intermediary.salesOverviewSection.cumulative,
    constants.v360ReportCodes.intermediary.salesOverviewSection.structure,
    constants.v360ReportCodes.salesPerson.salesOverviewSection.monthly,
    constants.v360ReportCodes.salesPerson.salesOverviewSection.cumulative,
    constants.v360ReportCodes.salesPerson.salesOverviewSection.structure,
];

const salesOverviewSectionPatternReports = [
    constants.v360ReportCodes.intermediary.salesOverviewSection.monthly,
    constants.v360ReportCodes.salesPerson.salesOverviewSection.monthly,
];

class SalesOverviewSectionReports extends CompanyBasedSectionReports {
    /**
     *
     */
    constructor() {
        super(salesOverviewSectionReports, salesOverviewSectionPatternReports);
    }
}

export default new SalesOverviewSectionReports();
